import { render, staticRenderFns } from "./SecurityButton.vue?vue&type=template&id=4751fb0c&scoped=true&"
import script from "./SecurityButton.vue?vue&type=script&lang=ts&"
export * from "./SecurityButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4751fb0c",
  null
  
)

export default component.exports